import uniqueId from 'lodash/uniqueId'
import products from '../fixtures/products.json'
import paginate from '../helpers/paginate'
import { TResponseResolver } from '../types'
import { transformList } from '__mocks__/helpers/find'

const delay = 800

const scene = [
  {
    id: uniqueId(),
    status: 'BLOCKED',
    steps: {
      blocklist: {
        message_type: 'SYSTEM_ERROR',
        step: 'ERROR',
      },
      marketplace: {
        message_type: '',
        step: 'NOT_STARTED',
      },
    },
  },
]

const items = products.map((item, index) => (scene[index] ? { ...scene[index], ...item } : item))

export const mockBrowse: TResponseResolver = async (req, res, ctx) => {
  const qs = req.url.searchParams
  const page = qs.get('page')
  const per_page = qs.get('per_page')
  return res(paginate({ page, per_page }), ctx.delay(delay), ctx.status(200), ctx.json(items))
}

export const mockById: TResponseResolver = async (req, res, ctx) => {
  const filter = transformList(list => list.find(item => item.id === req.params.id))
  return res(filter, ctx.delay(delay), ctx.status(200), ctx.json(items))
}
